import request from '@/libs/request'

export function settingUpdate (data) {
  return request({
    url: `level/updateSetting`,
    method: 'post',
    data
  })
}

// 用户列表
export function userLevelList (data) {
  return request({
    url: `user/userLevel`,
    method: 'get',
    params: data
  })
}
// 添加等级
export function addUserLevel (data) {
  return request({
    url: `user/userLevel/add`,
    method: 'post',
    data: data
  })
}

// 等级信息
export function getLevel (data) {
  return request({
    url: `user/userLevel_getDetail`,
    method: 'get',
    params: data
  })
}

export function deleteLevel (id) {
  let data = { level_id: id }
  return request({
    url: `user/userLevel/delete`,
    method: 'post',
    data: data
  })
}
